import React from 'react';
import { render } from 'react-dom';
import App from '$components/App';

const renderApp = () => render(
  <App />,
  window.document.getElementById('main')
);

export default renderApp;